/* eslint-disable react/require-default-props */

/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line import/no-extraneous-dependencies
import '@fontsource/poppins';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';

import * as React from 'react';
import { useState } from 'react';

// eslint-disable-next-line no-unused-vars
import { useLocation, useNavigate } from 'react-router-dom';

import Container from '@src/components/commons/containerPage.common';

import NotifAnnouncement from './notifAnnouncement';

function TabPanel(props) {
  const { children, value, index, style = {} } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={style}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function tabLabel(index) {
  return {
    id: `simple-tab-${index}`,
    poppins: `simple-tabpanel-${index}`,
  };
}

export default function NotificationPage() {
  const path = useLocation().pathname;
  const [value, setValue] = React.useState(() => {
    const savedTab = localStorage.getItem('appUserDoctorTab');
    return savedTab !== null ? Number(savedTab) : 0;
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
    localStorage.setItem('appUserDoctorTab', newValue);
  };

  return (
    <div>
      <Container pathUrl={path}>
        <Box sx={{ width: '100%' }} className='py-10'>
          <Box
            sx={{ borderBottom: 1, borderColor: 'divider' }}
            className=' border-gray-50'
          >
            <Tabs
              value={value}
              indicatorColor='white'
              onChange={handleChange}
              aria-label='basic tabs example'
              className='px-6'
            >
              <Tab
                sx={{
                  textTransform: 'none',
                  width: 'auto',
                  borderColor: 'blue',
                }}
                label='Announcement'
                className={`rounded-md border border-gray-300 font-bold text-cyan-600 ${
                  value === 0 ? 'bg-cyan-600 text-white' : 'bg-white'
                }`}
                {...tabLabel(0)}
              />
              <Box sx={{ width: '9px' }} />
              <Tab
                sx={{ textTransform: 'none', width: '140px' }}
                label='Marketing'
                className={`rounded-md border border-gray-300 font-bold text-cyan-600 ${
                  value === 2 ? 'bg-cyan-600 text-white' : 'bg-white'
                }`}
                {...tabLabel(1)}
              />
              <Box sx={{ width: '9px' }} />
              <Tab
                sx={{ textTransform: 'none', width: 'auto' }}
                label='Version Updates'
                className={`rounded-md border border-gray-300 font-bold text-cyan-600 ${
                  value === 4 ? 'bg-cyan-600 text-white' : 'bg-white'
                }`}
                {...tabLabel(2)}
              />
              <Box sx={{ width: '9px' }} />
              <Tab
                sx={{ textTransform: 'none', width: '140px' }}
                label='Others'
                className={`rounded-md border border-gray-300 font-bold text-cyan-600 ${
                  value === 6 ? 'bg-cyan-600 text-white' : 'bg-white'
                }`}
                {...tabLabel(3)}
              />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <NotifAnnouncement />
          </TabPanel>
          <TabPanel value={value} index={2}>
            2
          </TabPanel>
          <TabPanel value={value} index={4}>
            3
          </TabPanel>
          <TabPanel value={value} index={6}>
            4
          </TabPanel>
        </Box>
      </Container>
    </div>
  );
}
